import React from 'react';

const RESPONSIVE_SIZES = '(max-width: 768px) 100vw, 50vw';
const getResponsiveProps = (src, smallSrc) => (smallSrc ? { srcSet: `${smallSrc} 750w, ${src} 1200w`, sizes: RESPONSIVE_SIZES } : {});

const LazyImage = ({ alt, src, smallSrc, ...props }) => (
  <img alt={alt} src={src} loading='lazy' decoding='async' {...getResponsiveProps(src, smallSrc)} {...props} />
);

export default LazyImage;
